/**
 * PixiJS 2D Game - Main Entry
 */

import * as PIXI from 'pixi.js';
import { Application } from 'pixi.js';
import { Engine } from './engine/Engine';
import { MainScene } from './game/MainScene';
import { PlatformBridge } from './platform/Bridge';

// 暴露 PIXI 到全局（供 VAG DevTools 使用）
;(window as any).PIXI = PIXI;

async function main() {
  // 通知宿主：游戏开始加载
  FXclient?.game?.loading({ progress: 0, message: 'loading' })

  // Create PixiJS Application
  const app = new Application();
  
  await app.init({
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x0a0a15,
    antialias: true,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
  });

  // Add canvas to container
  const container = document.getElementById('game-container');
  if (container) {
    container.appendChild(app.canvas);
  }

  ;(app.canvas as any).__PIXI_APP__ = app

  // Initialize platform bridge
  const bridge = new PlatformBridge();

  // Create engine
  const engine = new Engine(app);

  // Create main scene
  const scene = new MainScene(engine);
  engine.setScene(scene);

  // Handle resize
  window.addEventListener('resize', () => {
    app.renderer.resize(window.innerWidth, window.innerHeight);
    scene.onResize(window.innerWidth, window.innerHeight);
  });

  // Listen for platform commands
  bridge.onCommand((cmd) => {
    switch (cmd.type) {
      case 'VAG_PREVIEW_PLAY':
        engine.play();
        break;
      case 'VAG_PREVIEW_PAUSE':
        engine.pause();
        break;
      case 'reset':
        engine.reset();
        break;
    }
  });

  // Start the game
  engine.start();

  // Focus canvas for keyboard input
  app.canvas.focus();
  app.canvas.tabIndex = 0;
}

main().catch(console.error);
